/**
 * Discord launches an activity by loading the app in an iframe whose URL always
 * carries a `frame_id` query parameter. Its presence is the only signal the
 * client gets before the SDK loads, so every Discord-only branch keys off it.
 */
const DISCORD_FRAME_PARAM = 'frame_id';

function currentSearch(): string {
  return typeof location === 'undefined' ? '' : location.search;
}

export function isDiscordActivity(search: string = currentSearch()): boolean {
  if (search === '') {
    return false;
  }

  return new URLSearchParams(search).has(DISCORD_FRAME_PARAM);
}
